<template>
  <div>
    <div v-if="this.$store.state.device.isMobile" style="height: 100vh; background-color: #1e90ff; background-image: linear-gradient(to top, #2B2D42, #1e90ff 25%)">
      <img class="logo" src="../../public/img/512.png">
      <div class="b-form">
        <b-form v-if="loginForm">
          <b-form-group style="margin-bottom: 10%">
            <legend>{{ $t('pages.Login.email') }}</legend>
            <b-form-input
                    class="input"
                    v-model="form.email"
                    type="text"
                    required
            ></b-form-input>
          </b-form-group>

          <b-form-group style="margin-bottom: 1.5%;">
            <legend>{{ $t('pages.Login.password') }}</legend>
            <b-form-input
                    class="input"
                    v-model="form.password"
                    type="password"
                    required
            ></b-form-input>
          </b-form-group>
          <div style="text-align: right;">
            <a v-on:click="forgotPassword" class="forgot">{{ $t('pages.Login.forgot') }}</a>
          </div>

          <b-button v-on:click="login" class="btnLogin" style="padding: 0;">{{ $t('pages.Login.login') }}</b-button>
          <div style="padding-top: 5%;">
            <a @click="changeToPt" class="lang" v-bind:style="[pt==true ? {'color': '#2B2D42', 'font-weight': '700'} : {'color': 'white'}]">PT</a>
            <span class="lang_seperator" style="color: white;">|</span>
            <a @click="changeToEn" class="lang" v-bind:style="[en==true ? {'color': '#2B2D42', 'font-weight': '700'} : {'color': 'white'}]">EN</a>
          </div>
        </b-form>
        <b-form v-if="forgotForm">
          <b-form-group style="margin-bottom: 10%">
            <legend style="margin-bottom: 5%;text-align: left;">{{ $t('pages.Login.sendEmailMessage') }}</legend>
            <b-form-input
                    class="input"
                    v-model="form.email"
                    type="text"
                    required
            ></b-form-input>
          </b-form-group>
          <b-button v-on:click="forgotPasswordButton" class="btnLogin" style="padding: 0;">{{ $t('pages.Login.sendEmail') }}</b-button>
          <div style="text-align: left;margin-top: 5%;">
            <a v-on:click="back" class="back"><i style="margin-right: 10px; color: white;" class="fas fa-chevron-left"></i>{{ $t('standard.back') }}</a>
          </div>
        </b-form>
      </div>
    </div>
    <div v-if="this.$store.state.device.isDesktop" style="height: 100vh; background-color: #1e90ff; background-image: linear-gradient(to top, #2B2D42, #1e90ff 50%)">
        <div class="container-desktop">
          <b-form v-if="loginForm">
            <img class="logo_desktop" src="../../public/img/512.png">
            <b-form-group style="margin: 20px 10% 20px;">
              <legend>{{ $t('pages.Login.email') }}</legend>
              <b-form-input
                      class="input"
                      v-model="form.email"
                      type="text"
                      required
              ></b-form-input>
            </b-form-group>
            <b-form-group style="margin: 10px 10% 0;">
              <legend>{{ $t('pages.Login.password') }}</legend>
              <b-form-input
                      class="input"
                      v-model="form.password"
                      type="password"
                      required
              ></b-form-input>
              <div style="text-align: right;padding-bottom: 20px;">
                <a v-on:click="forgotPassword" class="forgot">{{ $t('pages.Login.forgot') }}</a>
              </div>
            </b-form-group>
            <b-form-group  style="margin: 0px 10% 0;">
              <b-button v-on:click="login" class="btnLogin">{{ $t('pages.Login.login') }}</b-button>
            </b-form-group>
            <div style="padding-top: 5%; padding-bottom: 10%;">
              <a @click="changeToPt" class="lang" v-bind:style="[pt==true ? {'color': '#1e90ff', 'font-weight': '700'} : {'color': '#2B2D42'}]">PT</a>
              <span class="lang_seperator">|</span>
              <a @click="changeToEn" class="lang" v-bind:style="[en==true ? {'color': '#1e90ff', 'font-weight': '700'} : {'color': '#2B2D42'}]">EN</a>
            </div>
          </b-form>
          <b-form v-if="forgotForm">
            <img class="logo_desktop" src="../../public/img/512.png">
            <b-form-group style="margin: 10px 10% 0px;">
              <legend style="margin-bottom: 5%;text-align: left;">{{ $t('pages.Login.sendEmailMessage') }}</legend>
              <b-form-input
                      class="input"
                      v-model="form.email"
                      type="text"
                      required
              ></b-form-input>
            </b-form-group>
            <b-form-group style="margin: 10px 10% 0;">
              <b-button v-on:click="forgotPasswordButton" class="btnLogin" style="padding: 0;">{{ $t('pages.Login.sendEmail') }}</b-button>
              <div style="text-align: left;margin-top: 5%;">
                <a v-on:click="back" style="color: #2B2B2B;"><i style="margin-right: 10px; color: #2B2B2B;" class="fas fa-chevron-left"></i>{{ $t('standard.back') }}</a>
              </div>
            </b-form-group>
            
            <div style="padding-top: 5%; padding-bottom: 10%;">
              <a @click="changeToPt" class="lang" v-bind:style="[pt==true ? {'color': '#1e90ff', 'font-weight': '700'} : {'color': '#2B2D42'}]">PT</a>
              <span class="lang_seperator">|</span>
              <a @click="changeToEn" class="lang" v-bind:style="[en==true ? {'color': '#1e90ff', 'font-weight': '700'} : {'color': '#2B2D42'}]">EN</a>
            </div>
          </b-form>
        </div>
    </div>
  </div>
</template>

<script>
  import {getMembers} from "../main";
  import {login, forgotPassword} from "../api/Auth/apiAuth";
  import {configValues} from "../api/Config/apiConfig";
  import {mutations} from "../store/modules/device";
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');
  export default {
    name: "login",
    data() {
      return {
        width: null,
        loginForm: true,
        forgotForm: false,
        form: {
          email: "",
          password: ""
        },
        pt: null,
        en: null
      };
    },
    methods: {
      changeToEn: function() {
        this.$i18n.set('en');
        localStorage.setItem('language', 'en');
        this.en = true;
        this.pt = false;
      },
      changeToPt: function() {
        this.$i18n.set('pt');
        localStorage.setItem('language', 'pt');
        this.en = false;
        this.pt = true;
      },
      login: function() {
        let spinner = this.$loading.open();
        localStorage.clear();
        localStorage.setItem('language', 'pt');

        let login_authentication = {
          email: this.form.email,
          password: this.form.password
        };

        login(login_authentication)
                .then(response => {
                  var tokens = response.headers.authorization.split("#2$4%503&/()");
                  localStorage.setItem('email', this.form.email);
                  localStorage.setItem('token', tokens[0]);
                  configValues()
                    .then(response => {
                        mutations.changeColor(response.data.body[0].color);
                        mutations.changeOrganization(response.data.body[0].organization);
                        mutations.changeImage(response.data.body[0].image);
                        localStorage.setItem('color', response.data.body[0].color);
                        localStorage.setItem('organization', response.data.body[0].organization);
                        localStorage.setItem('image', response.data.body[0].image);
                        getMembers();
                        spinner.close();
                        this.$router.push("/dashboard").catch(error => {});
                    })
                })
                .catch(error => {
                  spinner.close();
                  if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                  else {
                    if(error.response.data.code == undefined) this.$toast.open({message: "Credenciais inválidas", type: 'is-danger'});
                    else this.$toast.open({message: error.response.data.code, type: 'is-danger'});
                  }
                })
      },
      forgotPassword: function () {
        this.forgotForm = true;
        this.loginForm = false;
      },
      forgotPasswordButton: function () {
        let spinner = this.$loading.open();
        forgotPassword({email: this.form.email}).then(response => {
          spinner.close();
          if(this.$i18n.locale()=='pt') this.$toast.open(pt.pages.Profile.messageSent);
          if(this.$i18n.locale()=='en') this.$toast.open(en.pages.Profile.messageSent);
          this.forgotForm = false;
          this.loginForm = true;
        }).catch((error) => {spinner.close();this.$toast.open({message: 'Email inválido', type: 'is-danger'})} );
      },
      back: function () {
        this.forgotForm = false;
        this.loginForm = true;
      }
    },
    mounted() {
      this.width = Math.max(self.innerWidth || 0, document.documentElement.clientWidth || 0, document.body.clientWidth || 0);
      localStorage.setItem('language', 'pt');
      if(localStorage.getItem('language')=='pt') this.pt=true;
      if(localStorage.getItem('language')=='en') this.en=true;
    }
  };
</script>

<style scoped>
  input {
    text-align: center;
  }
  form {
    width: 100% !important;
  }
  
  /*ADJUST MOBILE CSS*/
  @media (max-height: 750px) {
    .logo{
      width: 40%;
      padding-top: 10%;
      position: relative;
    }
  }
  @media (min-height: 750px) {
    .logo{
      width: 40%;
      padding-top: 20%;
      padding-bottom: 5%;
      position: relative;
    }
  }

  @media(max-width: 425px){
    .back {
      color: #ffffff;
    }
    .b-form {
      bottom: 0;
      margin: 10% 10% 10% 10%;
    }
    .btnLogin {
      height: 55px;
      width: 100%;
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 50px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      margin-top: 25px;
    }
    .input {
      background: white;
      border-radius: 32px;
      height: 47px;
    }
    legend {
      color: white;
      text-align: left;
      font-size: 16px;
      letter-spacing: 0.8px;
      margin-bottom: 2%;
    }
    .forgot {
      color: #ffffff;
      text-decoration: underline;
      font-size: 14px;
    }
    a:visited {
      color: white;
    }
    .lang {
      letter-spacing: 0.8px;
      font-size: 100%;
    }
    .lang_seperator {
      margin: 10px;
      color: #2B2D42;
    }
  }


  /*ADJUST TABLET AND DESKTOP CSS*/
  @media(min-width: 450px){
    .back {
      color: #ffffff;
      font-size: 150%;
    }
    .b-form {
      bottom: 0;
      margin: 10%;
    }
    .btnLogin {
      height: 55px;
      width: 100%;
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 50px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      padding: 0;
      margin-top: 25px;
    }
    .input {
      background: white;
      border-radius: 32px;
      height: 47px;
    }
    legend {
      color: #2B2D42;
      text-align: left;
      font-size: 100% !important;
      letter-spacing: 0.8px;
      margin-bottom: 2%;
    }
    .forgot {
      color: #2B2D42;
      text-decoration: underline;
      font-size: 80%;
    }
    .lang {
      letter-spacing: 0.8px;
      font-size: 125%;
    }
    .lang_seperator {
      margin: 10px;
      color: #2B2D42;
      font-size: 125%;
    }
  }

  @media (max-width: 800px) {
    .container-desktop {
      background-color: white;
      width: 70%;
      height: 85%;
      border-radius: 32px;
      position: absolute;
      top:0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (min-width: 800px) and (max-width: 1100px) {
    .container-desktop {
      background-color: white;
      width: 70%;
      height: 85%;
      border-radius: 32px;
      position: absolute;
      top:0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (min-width: 1100px)  {
    .container-desktop {
      background-color: white;
      width: 50%;
      height: 90%;
      border-radius: 32px;
      position: absolute;
      top:0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }


  @media (max-height: 700px) {
    .logo_desktop{
      width: 20%;
      padding-bottom: 2%;
      padding-top: 10%;
    }
  }
  @media (min-height: 700px) {
    .logo_desktop{
      width: 20%;
      padding-bottom: 2%;
      padding-top: 10%;
    }
  }
</style>
